import React from 'react';
import { Modal } from 'react-bootstrap';

const ConfirmSetAllItemModal = props => {
  const {
    showSetAllItemConfirmationModal,
    onClickCancel,
    onClickConfirm,
  } = props;

  return (
    <Modal show={showSetAllItemConfirmationModal}>
      <Modal.Header closeButton>
        <Modal.Title componentClass="div">
          Apply Modifier Set to All Items
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>Are you sure want to apply this modifier set to All Items?</div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            className="btn btn-default pull-left"
            onClick={onClickCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onClickConfirm}
          >
            Apply
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmSetAllItemModal;
